module.exports = __webpack_public_path__ + "static/cover_desktop-a6827a510963c1c69a25086de1737bf4.mp4";